export default "__VITE_ASSET__CziIZw1A__"